var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMisc03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_619_1940)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12146 6.01128C5.63624 4.79041 4.43278 3.33649 3.52843 1.64258C3.34756 1.30519 2.9267 1.17649 2.58583 1.35736C2.24844 1.53823 2.11972 1.95911 2.30059 2.29998C3.29538 4.15389 4.61018 5.74694 6.23801 7.08607C6.53366 7.32955 6.97538 7.2878 7.21886 6.99215C7.46234 6.69302 7.41711 6.25475 7.12146 6.01128Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32941 1.25651C6.40593 2.66172 6.47551 4.06694 6.56246 5.47216C6.58681 5.85477 6.91724 6.14694 7.29985 6.12259C7.68246 6.09824 7.97463 5.76781 7.95029 5.3852C7.86333 3.98346 7.79375 2.58173 7.71723 1.17651C7.69636 0.794949 7.36593 0.501034 6.98332 0.522599C6.60071 0.544164 6.30506 0.872855 6.32941 1.25651Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4933 1.54175C10.6029 2.88436 9.59426 4.1226 8.57861 5.37478C8.33513 5.67391 8.38032 6.11219 8.67945 6.35219C8.97858 6.59567 9.41686 6.55044 9.65686 6.2513C10.7003 4.96783 11.7369 3.6913 12.6551 2.31043C12.8673 1.99043 12.7768 1.55914 12.4568 1.34697C12.1403 1.13479 11.7055 1.22175 11.4933 1.54175Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9425 6.53304C12.5286 6.64086 9.9651 6.64434 7.55119 6.4913C7.16858 6.47043 6.83814 6.75913 6.8138 7.14521C6.78945 7.52782 7.08162 7.85825 7.46423 7.8826C9.92684 8.03565 12.5425 8.03217 15.0051 7.92434C15.3877 7.90695 15.6868 7.58 15.6694 7.19739C15.652 6.81479 15.3251 6.51564 14.9425 6.53304Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23612 6.97473C7.72481 8.79734 9.2657 10.5852 10.6466 12.4913C10.8727 12.8008 11.3075 12.8704 11.6205 12.6443C11.9301 12.4182 11.9996 11.9834 11.7735 11.6738C10.3753 9.74689 8.81702 7.9382 7.31093 6.09472C7.06745 5.79907 6.62917 5.75386 6.33352 5.99734C6.03439 6.24082 5.99264 6.67908 6.23612 6.97473Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68697 7.50359C7.07654 9.40272 7.18437 11.2184 7.21219 13.1419C7.21567 13.5245 7.5322 13.8305 7.91481 13.8271C8.3009 13.8201 8.60697 13.5071 8.60002 13.121C8.57219 11.1071 8.45742 9.21141 8.05047 7.22185C7.97047 6.8462 7.60525 6.6027 7.22612 6.6827C6.85047 6.75922 6.60697 7.12794 6.68697 7.50359Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74977 7.35061C5.62282 9.60453 5.04195 12.1089 3.83499 14.3141C3.65064 14.648 3.77583 15.0723 4.11322 15.2567C4.45062 15.441 4.87151 15.3158 5.05586 14.9819C6.26978 12.7628 6.85758 10.2445 7.99498 7.97322C8.16541 7.62887 8.02628 7.21148 7.68541 7.03756C7.34106 6.86713 6.92369 7.00627 6.74977 7.35061Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36999 6.83912C5.12651 7.23564 2.88651 7.41651 0.629121 7.68433C0.246512 7.72955 -0.0247922 8.07391 0.0204252 8.45652C0.0656426 8.83912 0.410023 9.11043 0.792631 9.06521C3.07437 8.79739 5.34219 8.60955 7.61349 8.20955C7.98915 8.13999 8.24306 7.77825 8.17697 7.40259C8.10741 7.02346 7.74912 6.76955 7.36999 6.83912Z",
    fill: "#7750BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93103 5.78192C8.46842 5.76105 8.03015 5.72974 7.57798 5.66365C7.19537 5.608 6.84406 5.87235 6.78841 6.25148C6.73275 6.63061 6.99708 6.9854 7.37621 7.04105C7.87708 7.11409 8.36057 7.14887 8.8684 7.16974C9.25101 7.18713 9.57795 6.89147 9.59186 6.50538C9.60925 6.12277 9.31364 5.79931 8.93103 5.78192Z",
    fill: "#7750BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_1940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc03);
export default __webpack_public_path__ + "static/media/Misc_03.38657fefa901cade1529db046c6e63ad.svg";
export { ForwardRef as ReactComponent };